<template>
<div class="relative">
    <div class="vx-navbar-wrapper">
        <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">

            <!-- SM - OPEN SIDEBAR BUTTON -->
            <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>

            <vx-tooltip position="bottom" text="Back" color="primary" >
                <vs-button color="primary" type="flat" class="px-1 mt-2 mx-2" @click="$router.go(-1)">
                    <font-awesome-icon :icon="leftIcon" />
                </vs-button>
            </vx-tooltip>

            <template v-if="breakpoint != 'sm'">
                <div class="flex ml-3" style="flex-direction: column;">
                    <h5>Admin Dashboard</h5>
                </div>
            </template>

            <vs-spacer></vs-spacer>

            <!-- USER META -->
            <div class="the-navbar__user-meta flex items-center">
                <div class="text-right leading-tight hidden sm:block">
                    <p class="font-semibold">{{ user_displayName }}</p>
                    <!-- <small>{{  user_displayRole  }}</small> -->
                </div>
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" style="min-width:40px">
                    <div class="con-img ml-3">
                        <img
                            v-if="activeUserImg.startsWith('http')"
                            key="onlineImg"
                            :src="activeUserImg"
                            alt="user-img"
                            width="40"
                            height="40"
                            class="rounded-full shadow-md cursor-pointer block" />
                        <img
                            v-else
                            key="localImg"
                            :src="require(`@/assets/images/portrait/small/${activeUserImg}`)"
                            alt="user-img"
                            width="40"
                            height="40"
                            class="rounded-full shadow-md cursor-pointer block"
                        />
                    </div>
                    <vs-dropdown-menu class="vx-navbar-dropdown">
                        <ul v-if="$store.state.is_online" style="min-width: 9rem">
                            <!-- <a :href="$store.state.apiendpoints.profile">
                                <li
                                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                >
                                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                                    <span class="ml-2">Profile</span>
                                </li>
                            </a> -->
                            <li
                                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                @click="$router.push({'name': 'page-logout'})"
                            >
                                <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                                <span class="ml-2">Logout</span>
                            </li>
<!--                            <li-->
<!--                                class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
<!--                                @click="$store.dispatch('updateTheme', $store.state.theme == 'light' ? 'dark' : 'light')"-->
<!--                            >-->

<!--                                <span class="ml-2">-->
<!--                                    <template v-if="$store.state.theme == 'light'">-->
<!--                                        Dark-->
<!--                                    </template>-->
<!--                                    <template v-else>-->
<!--                                        Light-->
<!--                                    </template>-->
<!--                                    Mode-->
<!--                                </span>-->
<!--                            </li>-->
                        </ul>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>
        </vs-navbar>
    </div>
</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import { faArrowLeft, faBell } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests';

export default {
    name: "the-navbar",
    props: {
        navbarColor: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            searchQuery: '',
            showFullSearch: false,
            unreadNotifications: [
                { index: 0, title: 'New Message', msg: 'Are your going to meet me tonight?', icon: 'MessageSquareIcon', time: this.randomDate({sec: 10}), category: 'primary' },
                { index: 1, title: 'New Order Recieved', msg: 'You got new order of goods.', icon: 'PackageIcon', time: this.randomDate({sec: 40}), category: 'success' },
                { index: 2, title: 'Server Limit Reached!', msg: 'Server have 99% CPU usage.', icon: 'AlertOctagonIcon', time: this.randomDate({min: 1}), category: 'danger' },
                { index: 3, title: 'New Mail From Peter', msg: 'Cake sesame snaps cupcake', icon: 'MailIcon', time: this.randomDate({min: 6}), category: 'primary' },
                { index: 4, title: 'Bruce\'s Party', msg: 'Chocolate cake oat cake tiramisu', icon: 'CalendarIcon', time: this.randomDate({hr: 2}), category: 'warning' },
            ],
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            autoFocusSearch: false,
            showBookmarkPagesDropdown: false,
        }
    },
    watch: {
        '$route'() {
            if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
        }
    },
    computed: {
        leftIcon: () => faArrowLeft,
        bell: () => faBell,
        // HELPER
        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },
        breakpoint() {
            return this.$store.state.breakpoint;
        },

        // NAVBAR STYLE
        classObj() {
            if (this.sidebarWidth == "default") return "navbar-default"
            else if (this.sidebarWidth == "reduced") return "navbar-reduced"
            else if (this.sidebarWidth) return "navbar-full"
        },

        // I18N
        getCurrentLocaleData() {
            const locale = this.$i18n.locale;
            if (locale == "en") return { flag: "us", lang: 'English' }
            else if (locale == "pt") return { flag: "br", lang: 'Portuguese' }
            else if (locale == "fr") return { flag: "fr", lang: 'French' }
            else if (locale == "de") return { flag: "de", lang: 'German' }
        },

        // BOOKMARK & SEARCH
        data() {
            return this.$store.state.navbarSearchAndPinList;
        },
        starredPages() {
            return this.$store.state.starredPages;
        },
        starredPagesLimited: {
            get() {
                return this.starredPages.slice(0, 10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesLimited', list);
            }
        },
        starredPagesMore: {
            get() {
                return this.starredPages.slice(10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesMore', list);
            }
        },

        // CART DROPDOWN
        cartItems() {
            return this.$store.state.eCommerce.cartItems.slice().reverse();
        },

        // PROFILE
        user_displayName() {
            if (!this.$store.getters.userInfo) return "Visitor"
            return `${this.$store.getters.userInfo.first_name} ${this.$store.getters.userInfo.last_name || ''}`
        },
        activeUserImg() {
            return this.$store.getters.userInfo.avatar || this.$store.state.AppActiveUser.img;
        },
        user_displayRole() {
            const roles = {
                'a': 'Admin',
                's': 'Site Engineer',
                'm': 'Maintenance Manager',
                'i': 'Incident Manager',
                'o': 'Patrol Officer',
                'v': 'Vendor',
                'p': 'Project Incharge',
                'r': 'Project Manager',
                'c': 'CXO'
            }

            if (this.$store.state.organisation.organisation_user) {
                return roles[this.$store.state.organisation.organisation_user.role] || 'Unknown Role'
            }

            return 'Super Admin'
        }
    },
    methods: {
        updateLocale(locale) {
            this.$i18n.locale = locale;
        },
        showSidebar() {
            this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
        },
        selected(item) {
            this.$router.push(item.url)
            this.showFullSearch = false;
        },
        actionClicked(item) {
            // e.stopPropogation();
            this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction });
        },
        showNavbarSearch() {
            this.showFullSearch = true;
        },
        showSearchbar() {
            this.showFullSearch = true;
        },
        elapsedTime(startTime) {
            let x = new Date(startTime);
            let now = new Date();
            var timeDiff = now - x;
            timeDiff /= 1000;

            var seconds = Math.round(timeDiff);
            timeDiff = Math.floor(timeDiff / 60);

            var minutes = Math.round(timeDiff % 60);
            timeDiff = Math.floor(timeDiff / 60);

            var hours = Math.round(timeDiff % 24);
            timeDiff = Math.floor(timeDiff / 24);

            var days = Math.round(timeDiff % 365);
            timeDiff = Math.floor(timeDiff / 365);

            var years = timeDiff;

            if (years > 0) {
                return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
            } else if (days > 0) {
                return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
            } else if (hours > 0) {
                return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
            } else if (seconds > 0) {
                return seconds + (seconds > 1 ? ' sec ago' : 'just now');
            }

            return 'Just Now'
        },
        logout() {
            // if user is logged in via auth0
            if (this.$auth.profile) this.$auth.logOut();

            // if user is looged in via firebase
            const firebaseCurrentUser = firebase.auth().currentUser

            if (firebaseCurrentUser) {
                firebase.auth().signOut().then(() => {
                    this.$router.push('/accounts/login')
                    localStorage.removeItem('userInfo');
                })
            }
            // Change role on logout. Same value as initialRole of acj.js
            this.$acl.change('admin')
            localStorage.removeItem('userRole');
        },
        outside: function() {
            this.showBookmarkPagesDropdown = false
        },

        // CART DROPDOWN
        removeItemFromCart(item) {
            this.$store.dispatch('eCommerce/toggleItemInCart', item)
        },

        // Method for creating dummy notification time
        randomDate({hr, min, sec}) {
          let date = new Date()

          if(hr) date.setHours(date.getHours() - hr)
          if(min) date.setMinutes(date.getMinutes() - min)
          if(sec) date.setSeconds(date.getSeconds() - sec)

          return date
        },
    },
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                document.addEventListener('click', handler)
            },

            unbind: function(el) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },
    components: {
        VxAutoSuggest,
        VuePerfectScrollbar,
        draggable,
    },
}
</script>

<style lang="scss">
.vx-navbar {
    @media all and  (max-width: 768px) {
        h5 {
            font-size: 1rem;
        }
    }
}
.badge {
    height: 2em;
    width: 2em;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -9px;
    margin-right: -2px;
    position: absolute;
    top: 0;
    right: 0;
    background-color: red;
    color: white;
    font-size: 0.6em;
    font-weight: bold;
    border-radius: 50%;
}

</style>
